<app-side-nav></app-side-nav>

<div class="p-4 max-w-2xl mx-auto font-[Inter] space-y-4 pb-40 pb-24">
  <div class="md:hidden fixed top-0 left-0 right-0 z-40"
     [style.height.px]="(headerHpx || 80) - 8"
     [ngClass]="!isDarkMode() ? 'bg-white' : 'bg-[#111827]'">
  </div>

  <!-- 🔹 HEADER MOBILE (fixe, centré, coins arrondis) – premium violet (light only) -->
  <div class="md:hidden fixed top-0 left-0 right-0 z-50 px-4 pt-[env(safe-area-inset-top)]">
    <div #mobileHeader
         class="max-w-md mx-auto rounded-2xl p-4 border transition-all backdrop-blur-md shadow-md"
         [ngClass]="isDarkMode()
       ? 'bg-[#1e1e2f] border-indigo-500/10'
       : 'bg-gradient-to-b from-[#F7F4FF] to-[#EEF0FF] border-[#E6E0FF] shadow-[0_6px_24px_rgba(123,97,255,0.06)]'">

      <!-- Ligne 1 : Titre -->
      <div class="flex items-center gap-2 mb-3">
        <svg class="w-6 h-6 md:w-7 md:h-7"
             [ngClass]="invBridgeLogo"
             fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M13 10V3L4 14h7v7l9-11h-7z" />
        </svg>
        <h1 class="text-lg font-extrabold tracking-tight text-purple-600 drop-shadow-[0_1px_2px_rgba(0,0,0,0.25)]">
          SwapTokens.app
        </h1>
      </div>

      <!-- Ligne 2 : About + Thème -->
      <div class="flex items-center justify-between px-1">
        <!-- Titre “À propos” sobre (même hiérarchie que Disclaimer) -->
        <h1 class="text-base sm:text-lg font-semibold text-purple-600 dark:text-purple-400">
          {{ 'ABOUT_TITLE' | translate }}
        </h1>

        <!-- Theme -->
        <button (click)="toggleTheme()"
                class="flex items-center justify-center px-3 py-1 rounded-full border transition"
                [ngClass]="isDarkMode()
              ? 'border-white/10 bg-purple-400/10'
              : 'border-[#E6E0FF] bg-white/80 hover:bg-white'">
          <svg *ngIf="isDarkMode(); else lightIcon" class="w-5 h-5 text-purple-300" fill="none"
               stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
            <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
          </svg>
          <ng-template #lightIcon>
            <svg class="w-5 h-5 text-purple-500" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
              <circle cx="12" cy="12" r="5" />
              <line x1="12" y1="1" x2="12" y2="3" />
              <line x1="12" y1="21" x2="12" y2="23" />
              <line x1="4.22" y1="4.22" x2="5.64" y2="5.64" />
              <line x1="18.36" y1="18.36" x2="19.78" y2="19.78" />
              <line x1="1" y1="12" x2="3" y2="12" />
              <line x1="21" y1="12" x2="23" y2="12" />
              <line x1="4.22" y1="19.78" x2="5.64" y2="18.36" />
              <line x1="18.36" y1="5.64" x2="19.78" y2="4.22" />
            </svg>
          </ng-template>
        </button>
      </div>
    </div>
  </div>

  <!-- Spacer mobile auto (UN SEUL) -->
  <div class="md:hidden" [style.height.px]="headerHpx || 80"></div>

  <!-- 🔥 HEADER DESKTOP – version premium violette harmonisée -->
  <div class="hidden md:block relative mb-4 rounded-2xl overflow-hidden">
    <div class="relative rounded-2xl p-4 border transition-all backdrop-blur-md hover:border-purple-400/20"
         [ngClass]="isDarkMode()
       ? 'bg-[#1e1e2f]/70 border-indigo-500/10 shadow-md dark:shadow-purple-900/10'
       : 'bg-gradient-to-b from-[#F7F4FF] to-[#EEF0FF] border-[#E6E0FF] shadow-[0_6px_24px_rgba(123,97,255,0.06)]'">

      <div class="flex justify-between items-center gap-4 mb-3">
        <div class="flex items-center gap-2">
          <svg class="w-6 h-6 md:w-7 md:h-7" [ngClass]="invBridgeLogo" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M13 10V3L4 14h7v7l9-11h-7z" />
          </svg>

          <!-- Brand -->
          <h1 class="text-base sm:text-lg md:text-2xl font-extrabold bg-clip-text text-transparent"
              [ngClass]="isDarkMode()
            ? invBridgeGradient
            : 'bg-gradient-to-r from-purple-600 to-indigo-600'">
            SwapTokens.app
          </h1>
        </div>

        <!-- Titre “À propos” sobre -->
        <h1 class="text-base sm:text-lg font-semibold text-purple-600 dark:text-purple-400">
          {{ 'ABOUT_TITLE' | translate }}
        </h1>
      </div>
    </div>
  </div>

  <!-- 🧭 Objet / Présentation (puces sobres si besoin de plusieurs phrases) -->
  <div class="rounded-2xl p-5 border shadow-md backdrop-blur-md mt-2"
       [ngClass]="isDarkMode()
         ? 'bg-[#1e1e2f]/70 border-indigo-500/10 text-white'
         : 'bg-gradient-to-b from-[#F7F4FF] to-[#EEF0FF] border-[#E6E0FF] text-black shadow-[0_6px_24px_rgba(123,97,255,0.06)]'">
    <p class="text-sm leading-relaxed">
      {{ 'ABOUT_OBJECTIVE' | translate }}
    </p>
  </div>

  <!-- ⚙️ Fonctionnalités (remplacées par des puces simples) -->
  <div class="rounded-2xl p-5 border shadow-md backdrop-blur-md"
       [ngClass]="isDarkMode()
         ? 'bg-[#1e1e2f]/70 border-indigo-500/10 text-white'
         : 'bg-gradient-to-b from-[#F7F4FF] to-[#EEF0FF] border-[#E6E0FF] text-black shadow-[0_6px_24px_rgba(123,97,255,0.06)]'">
    <ul class="list-disc pl-5 text-sm space-y-1.5 leading-relaxed">
      <li>{{ 'ABOUT_FEATURE_MARKET_DATA' | translate }}</li>
      <li>
        <span class="font-semibold">{{ 'ABOUT_FEATURE_NON_CUSTODIAL' | translate }}</span>
        <span class="ml-2 px-2 py-0.5 text-xs rounded-full align-middle"
              [ngClass]="isDarkMode()
                ? 'bg-green-700/30 text-green-300'
                : 'bg-green-100 text-green-800'">
          {{ 'ABOUT_FEATURE_TAG' | translate }}
        </span>
      </li>
    </ul>
  </div>

  <!-- 👤 Créateur (emoji supprimé, bloc sobre) -->
  <div class="rounded-2xl p-5 border shadow-md backdrop-blur-md"
       [ngClass]="isDarkMode()
         ? 'bg-[#1e1e2f]/70 border-indigo-500/10 text-white'
         : 'bg-gradient-to-b from-[#F7F4FF] to-[#EEF0FF] border-[#E6E0FF] text-black shadow-[0_6px_24px_rgba(123,97,255,0.06)]'">
    <p class="text-sm leading-relaxed">
      {{ 'ABOUT_CREATOR' | translate }}
    </p>
  </div>

  <!-- ✉️ Contact (emoji supprimé, lien violet aligné à la charte) -->
  <div class="rounded-2xl p-5 border shadow-md backdrop-blur-md flex items-start justify-between"
       [ngClass]="isDarkMode()
         ? 'bg-[#1e1e2f]/70 border-indigo-500/10 text-white'
         : 'bg-gradient-to-b from-[#F7F4FF] to-[#EEF0FF] border-[#E6E0FF] text-black shadow-[0_6px_24px_rgba(123,97,255,0.06)]'">
    <a href="mailto:contact@swaptokens.app"
       class="text-purple-700 hover:text-purple-800 underline dark:text-purple-300 dark:hover:text-purple-200 transition-all duration-200">
      contact&#64;swaptokens.app
    </a>
    <button onclick="navigator.clipboard.writeText('contact@swaptokens.app')"
            class="text-xs text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-200 transition"
            title="{{ 'ABOUT_COPY_EMAIL' | translate }}">
      Copy
    </button>
  </div>

  <!-- 🔻 Footer -->
  <div class="text-sm text-gray-500 text-center pt-6">
    {{ 'ABOUT_SUBSCRIPTIONS_COMING' | translate }}
    <div class="mt-2 inline-block px-3 py-1 bg-purple-900 text-purple-300 text-xs rounded-full font-medium">
      {{ 'ABOUT_FOOTER_TAG' | translate }}
    </div>
  </div>

</div>

<!-- Backdrop (clique dehors => ferme) -->
<div *ngIf="showFooterMenu"
     class="fixed inset-0 z-[59]"
     (click)="closeFooterMenu()"></div>

<!-- Sous-menu Info (mobile) -->
<ul *ngIf="showFooterMenu"
    class="fixed z-[10000] bottom-[72px] left-4 w-[90vw] max-w-xs rounded-2xl shadow-lg border transition-all duration-300 ease-in-out
     backdrop-blur-md backdrop-saturate-150"
    [ngClass]="isDarkMode()
      ? 'bg-gray-900/20 text-white border-white/10'
      : 'bg-white/20 text-gray-800 border-black/10'"
    (click)="$event.stopPropagation()">
  <li>
    <a routerLink="/a-propos"
       (click)="showFooterMenu = false"
       class="block px-4 py-3 rounded-lg border border-transparent hover:border-purple-500 transition duration-200 text-sm font-semibold"
       [ngClass]="isDarkMode() ? 'text-purple-300' : 'text-purple-700'">
      {{ 'ABOUT' | translate }}
    </a>
  </li>

  <li>
    <a routerLink="/disclaimer"
       (click)="showFooterMenu = false"
       class="block px-4 py-3 rounded-lg border border-transparent hover:border-purple-500 transition duration-200 text-sm font-semibold"
       [ngClass]="isDarkMode() ? 'text-purple-300' : 'text-purple-700'">
      {{ 'DISCLAIMER_NAV' | translate }}
    </a>
  </li>
</ul>

<app-settings *ngIf="showSettings" class="fixed bottom-[260px] right-4 z-[9999] w-[300px] rounded shadow-lg"
              (currencyChange)="onCurrencyChanged?.($event)"></app-settings>

<div class="md:hidden h-20"></div>
<app-footer-nav mode="default" (settingsClick)="showSettings = !showSettings" (infoClick)="toggleFooterMenu()"></app-footer-nav>
